@if (isVisible()) {
  <div class="clickterm-promo">
    <div class="clickterm-promo__text">
      <div class="clickterm-promo__heading">
        <h3 class="clickterm-promo__title">Something new from the TelQ team</h3>
        <span class="clickterm-promo__badge">New</span>
      </div>
      <p class="clickterm-promo__subtitle">
        We've been building ClickTerm, clickwrap agreements that make your terms legally binding, with an audit trail for every acceptance. If your
        product asks users to agree to anything, it will save your team the engineering.
      </p>
    </div>

    <div class="clickterm-promo__actions">
      <!-- rel is deliberately "noopener" only: "noreferrer" would strip the referrer header,
           which is our fallback attribution signal when the UTM params get lost. -->
      <a class="btn btn-primary clickterm-promo__cta" [href]="promoUrl()" target="_blank" rel="noopener" (click)="onPromoClick()">
        Explore ClickTerm
      </a>
      <button type="button" class="clickterm-promo__dismiss" aria-label="Dismiss ClickTerm promotion" (click)="onDismiss()">
        <span class="icon-close" aria-hidden="true"></span>
      </button>
    </div>
  </div>
}
